var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #167ee6 } \n\t\t.s1 { fill: #12b347 } \n\t\t.s2 { fill: #0f993e } \n\t\t.s3 { fill: #ffd500 } \n\t\t.s4 { fill: #ff4b26 } \n\t\t.s5 { fill: #d93f21 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m24.9 11c0.1 0.5 0.1 1 0.1 1.6 0 4.5-2.3 8.4-6.2 10.7l-2.5-4.2c1.5-0.9 2.7-2.3 3.3-3.9h-5.7c-0.5 0-0.9-0.4-0.9-0.8v-3.3c0-0.4 0.4-0.8 0.9-0.8h10.2c0.4 0 0.7 0.3 0.8 0.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m16.3 19.1l2.4 4.2c-1.8 1.1-3.9 1.7-6.2 1.7-4.6 0-8.7-2.5-10.8-6.3l4.2-2.4c1.3 2.3 3.8 3.8 6.6 3.8 1.4 0 2.7-0.4 3.8-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m12.5 25v-4.9c1.4 0 2.7-0.4 3.8-1l2.5 4.2c-1.9 1.1-4 1.7-6.3 1.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m5.9 16.3l-4.2 2.4c-1.1-1.8-1.7-3.9-1.7-6.2 0-2.3 0.6-4.4 1.7-6.2l4.2 2.4c-0.6 1.1-1 2.4-1 3.8 0 1.4 0.4 2.7 1 3.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m5.9 8.7l-4.2-2.4c2.1-3.8 6.2-6.3 10.8-6.3 3.1 0 6 1.2 8.2 3.1 0.3 0.3 0.4 0.8 0 1.2l-2.3 2.3c-0.3 0.3-0.7 0.3-1.1 0-1.3-1.1-3-1.7-4.8-1.7-2.8 0-5.3 1.5-6.6 3.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m12.5 4.9v-4.9c3.1 0 6 1.2 8.2 3.1 0.3 0.3 0.4 0.8 0 1.2l-2.3 2.3c-0.3 0.3-0.7 0.3-1.1 0-1.3-1.1-3-1.7-4.8-1.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4a14f84d276435000bcd4483fb3e3b26.svg";
export { ForwardRef as ReactComponent };